import React, { ReactNode } from 'react';
import { Box, Typography, Stack } from '@mui/material';

interface FeatureItemProps {
  icon: ReactNode;
  label: string;
  iconColor?: string;
}

export const FeatureItem: React.FC<FeatureItemProps> = ({
  icon,
  label,
  iconColor,
}) => (
  <Stack direction="row" alignItems="center" spacing={1.5}>
    <Box sx={{ color: iconColor }}>{icon}</Box>
    <Typography variant="body1" fontWeight="medium" pt={0.5}>
      {label}
    </Typography>
  </Stack>
);
